import gql from 'graphql-tag';

export const gqlGet = gql`
  query getCollectionpointGeocoding($where: String, $limit: Int) {
    getCollectionpointGeocoding(where: $where, limit: $limit) {
      data {
        latitude
        longitude
        collectionpoint {
          id
          name
          addressLine1
          addressCity
          postalCode
          profession {
            id
            name
          }
          isRechargePoint
        }
      }
    }
  }
`;

export const gqlGetAggr = gql`
  query getCollectionpointGeocodingAggrV2(
    $grouping: String
    $fromLat: Float
    $tillLat: Float
    $fromLon: Float
    $tillLon: Float
    $isRechargePoint: Boolean
  ) {
    getCollectionpointGeocodingAggrV2(
      grouping: $grouping
      fromLat: $fromLat
      tillLat: $tillLat
      fromLon: $fromLon
      tillLon: $tillLon
      isRechargePoint: $isRechargePoint
    ) {
      name
      value
      latitude
      longitude
    }
  }
`;
